module.exports = __webpack_public_path__ + "static/media/1a_Transparent.3baf9b00.png";